import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

export default function Solutions() {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = 'Non-Clonable Anti-Counterfeit Solutions for Brands | QRmor';
        const metaDesc = document.querySelector('meta[name="description"]');
        const content = 'Prevent counterfeit distribution across pharma, retail, and manufacturing. QRmor provides real-time verification and precise location-aware scan tracking.';
        if (metaDesc) {
            metaDesc.setAttribute('content', content);
        } else {
            const tag = document.createElement('meta');
            tag.name = 'description';
            tag.content = content;
            document.head.appendChild(tag);
        }
    }, []);

    return (
        <>
            <header>
                <nav className="wrap">
                    <div className="brand">
                        <img src="/assets/QRmor.png" alt="QRmor logo" />
                    </div>
                    <Link to="/" className="btn btn-primary btn-sm">Back to home</Link>
                </nav>
            </header>

            <section>
                <div className="wrap legal-content" style={{ maxWidth: 860, padding: '48px 32px 80px' }}>
                    <span className="eyebrow">Solutions</span>
                    <h1 style={{ fontSize: 'clamp(28px, 4vw, 40px)', marginTop: 12, marginBottom: 20 }}>
                        Non-Clonable Anti-Counterfeit Solutions for Pharma, FMCG &amp; Manufacturing
                    </h1>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
                        <div>
                            <p style={{ color: 'var(--ink-soft)', fontSize: 16, lineHeight: 1.7 }}>
                                Counterfeit distribution and supply chain fraud cost regulated industries far
                                more than lost revenue — in pharma, a fake medicine is a patient safety risk;
                                in FMCG and manufacturing, duplicate packaging erodes the brand trust a company
                                spends years building. QRmor's non-clonable QR code technology gives every
                                product a verification layer that a standard 2D barcode or DataMatrix code
                                cannot offer.
                            </p>
                        </div>

                        <div>
                            <h3>Pharma &amp; Healthcare</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8, lineHeight: 1.7 }}>
                                Built to align with GAMP and 21 CFR Part 11 guideline expectations, and with
                                India's Schedule H2 track-and-trace mandate covering vaccines, antimicrobials,
                                anti-cancer medicines, and narcotic and psychotropic drugs. Every scan — genuine
                                or flagged — is logged with a timestamp and location, giving manufacturers a
                                ready audit trail without reworking existing compliance processes.
                            </p>
                        </div>

                        <div>
                            <h3>FMCG &amp; Packaged Goods</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8, lineHeight: 1.7 }}>
                                Serial reproduction of packaging is one of the most common forms of counterfeit
                                distribution in fast-moving consumer goods. QRmor codes are integrated once into
                                product artwork, so brands avoid the cost and hassle of separate per-unit online
                                printing while still catching cloned packaging the moment it's scanned.
                            </p>
                        </div>

                        <div>
                            <h3>Manufacturing &amp; Automobiles</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8, lineHeight: 1.7 }}>
                                Component-level and spare-parts counterfeiting is a growing risk across
                                manufacturing and automotive supply chains. QRmor's SKU-wise licensing lets a
                                manufacturer protect specific parts or product lines individually, scaling
                                protection as new lines need it rather than committing to a blanket rollout.
                            </p>
                        </div>

                        <div>
                            <h3>How it fits your rollout</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8, lineHeight: 1.7 }}>
                                No new hardware or software is needed on the production line, and customers
                                verify with a smartphone camera — no app required. Real-time, location-aware
                                scan tracking means suspicious activity surfaces as it happens, not in a
                                quarterly report.
                            </p>
                        </div>
                    </div>

                    <div style={{ marginTop: 40 }}>
                        <a href="/#contact" className="btn btn-primary">Request a demo</a>
                    </div>
                </div>
            </section>
        </>
    );
}